import { Field, reduxForm } from 'redux-form'
import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import FadeIn from 'react-fade-in'

import { swipeActions } from 'redux/actions/SwipeActions'
import swipeSelectors from 'redux/selectors/SwipeSelectors'
import { Input, RoundButton, AppliedFiltersBanner } from 'components'
import i18n from 'services/i18n'

import s from './NameSearch.module.scss'

// Clear button icon component
const ClearIcon = ({ onClick, className }) => (
  <button
    type="button"
    onClick={onClick}
    className={className}
    aria-label="Clear field"
  >
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </button>
)

// Custom Input component with clear functionality
const InputWithClear = ({ input, meta, ...props }) => {
  const hasValue = input.value && input.value.trim().length > 0

  const handleClear = () => {
    input.onChange('')
  }

  // Create modified input object with autocomplete disabled
  // Using multiple techniques to ensure autocomplete is fully disabled
  const randomString = Math.random().toString(36).substring(7)
  const modifiedInput = {
    ...input,
    autoComplete: "nope-" + randomString, // Random string to confuse browsers
    autoCorrect: "off",
    autoCapitalize: "off",
    spellCheck: "false",
    'data-lpignore': "true", // LastPass ignore
    'data-form-type': "other", // Additional browser hint
    'data-1p-ignore': "true", // 1Password ignore
    'data-bwignore': "true", // Bitwarden ignore
    role: "presentation" // Additional accessibility hint
  }

  return (
    <Input
      {...props}
      input={modifiedInput}
      meta={meta}
      rightAdornment={
        hasValue ? (
          <ClearIcon onClick={handleClear} className={s.clearButton} />
        ) : null
      }
    />
  )
}

const NameSearchCmp = ({ handleSubmit, history }) => (
  <FadeIn>
    <section className={s.container}>
      <AppliedFiltersBanner history={history} />
      {/* Hidden dummy inputs to confuse browser autocomplete */}
      <input
        type="text"
        name="dummy-username"
        autoComplete="username"
        style={{ display: 'none' }}
        tabIndex="-1"
        aria-hidden="true"
      />
      <input
        type="password"
        name="dummy-password"
        autoComplete="new-password"
        style={{ display: 'none' }}
        tabIndex="-1"
        aria-hidden="true"
      />

      <Field
        name='firstName'
        label={i18n.t('search.firstName')}
        component={InputWithClear}
        props={{ 'data-autocomplete-field': 'search-first-name' }}
      />
      <Field
        name='lastName'
        label={i18n.t('search.lastName')}
        component={InputWithClear}
        props={{ 'data-autocomplete-field': 'search-last-name' }}
      />
      <RoundButton onClick={handleSubmit} className={s.button}>{i18n.t('search.submit')}</RoundButton>
    </section>
  </FadeIn>
)

export const NameSearchForm = reduxForm({
  form: 'nameSearch'
})(NameSearchCmp)

const mapStateToProps = createStructuredSelector({
  initialValues: swipeSelectors.searchNameValuesSelector
})

const mapDispatchToProps = {
  onSubmit: values => dispatch => dispatch(swipeActions.setSearchValues({ ...values, fromSearchName: true }))
}

export const NameSearch = connect(mapStateToProps, mapDispatchToProps)(NameSearchForm)
